import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { LabOrder } from 'src/app/Models/laborder.model';
import { Patient } from 'src/app/Models/patient.model';
import { LabOrderService } from 'src/app/services/lab-order.service';
import { PatientService } from 'src/app/services/patient.service';

@Component({
  selector: 'app-view-new-lab-order',
  templateUrl: './view-new-lab-order.component.html',
  styleUrls: ['./view-new-lab-order.component.css'],
})
export class ViewNewLabOrderComponent implements OnInit {
  displayedColumns: string[] = [
    'Date',
    'OrderedBy',
    'Subject',
    'Description',
    'View',
  ];

  id = 0;
  labOrder: LabOrder[] = [];
  dataSource: MatTableDataSource<any>;
  labDocument: string = '';
  patient: Patient;
  date: string;

  constructor(
    private patientService: PatientService,
    private labOrderservice: LabOrderService,
    private route: ActivatedRoute,
    private router: Router,
    private datePipe: DatePipe
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((res) => {
      this.id = res['id'];
    });

    this.GetlabReports(this.id);
    this.getPatient(this.id);

    // this.date = new Date(moment().format('MM/DD/YYYY')).toISOString()
    this.date = this.datePipe.transform(new Date(), 'MM/dd/YYYY');
  }
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  // ngAfterViewInit() {
  //   this.dataSource.paginator = this.paginator;
  //   this.dataSource.sort = this.sort;
  // }

  getPatient(id) {
    this.patientService.getPatientById(id).subscribe((res) => {
      this.patient = res;
    });
  }
  GetlabReports(id) {
    this.patientService.getPatienLabOrder(id).subscribe((res) => {
      this.dataSource = new MatTableDataSource(
        res.LabOrders.filter((x) => x.Date == this.date)
      );
      this.dataSource.paginator = this.paginator;
    });
  }
  delete(id) {
    this.labOrderservice.deleteLabOrder(id).subscribe((res) => {
      this.GetlabReports(this.id);
    });
  }
  print() {
    window.print();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  public viewLabReport(report: LabOrder): void {
    // console.log('report: ', report);
    this.labDocument = report.Description;
  }

  tabChanged(event: MatTabChangeEvent): void {
    if (event.index === 0) {
      this.GetlabReports(this.id);
    }
  }
}
